import { render } from "./AmendmentBox.vue?vue&type=template&id=38d2634b&scoped=true"
import script from "./AmendmentBox.vue?vue&type=script&lang=js"
export * from "./AmendmentBox.vue?vue&type=script&lang=js"

import "./AmendmentBox.vue?vue&type=style&index=0&id=38d2634b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d2634b"]])

export default __exports__